<p>image-upload-modal works!</p>
